// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-input-wrapper {
  width: 100%;
}

.tag-input-box {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  min-height: 42px;
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: white;
  cursor: text;
  transition: border-color 0.2s;
}

.tag-input-box:focus-within {
  border-color: #111827;
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.08);
}

.label-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 800;
}

.tag-remove {
  background: none;
  border: none;
  color: #93c5fd;
  font-size: 15px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.tag-remove:hover {
  color: #1d4ed8;
}

.tag-text-input {
  border: none;
  outline: none;
  font-size: 13px;
  color: #374151;
  flex: 1 1;
  min-width: 100px;
  background: transparent;
}

.tag-text-input::placeholder {
  color: #9ca3af;
}

.prelabel-card-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.prelabel-card-section > span {
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.mode-toggle {
  display: flex;
  gap: 0;
  width: 100%;
  border: 1px solid #d8e0ec;
  border-radius: 8px;
  background: #f8fafc;
  padding: 4px;
  overflow: hidden;
}

.mode-btn {
  flex: 1 1;
  min-height: 38px;
  padding: 8px 6px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease;
}

.mode-btn.active {
  background: #111827;
  color: #fff;
}

.mode-btn.active:hover {
  background: #1f2937;
}

.mode-btn:hover:not(.active) {
  background: #fff;
  color: #0f172a;
}

.model-select-wrapper {
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
}

.model-button-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.model-button-group .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.dinov2-image-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 12px; }
.dinov2-image-tile { display: flex; flex-direction: column; gap: 4px; min-width: 0; padding: 6px; background: white; border: 2px solid #ddd; border-radius: 8px; }
.dinov2-image-tile.selected { border-color: #2563eb; background: #eff6ff; }
.dinov2-image-tile img { width: 100%; height: 110px; object-fit: contain; }
.dinov2-image-tile span { overflow-wrap: anywhere; font-size: 12px; }
`, "",{"version":3,"sources":["webpack://./src/pages/PreLabelPage/LocalInferencePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,qBAAqB,aAAa,EAAE,4DAA4D,EAAE,SAAS,EAAE;AAC7G,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,YAAY,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;AACjK,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;AAC1E,yBAAyB,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE;AAC1E,0BAA0B,uBAAuB,EAAE,eAAe,EAAE","sourcesContent":[".tag-input-wrapper {\n  width: 100%;\n}\n\n.tag-input-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  min-height: 42px;\n  padding: 6px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: white;\n  cursor: text;\n  transition: border-color 0.2s;\n}\n\n.tag-input-box:focus-within {\n  border-color: #111827;\n  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.08);\n}\n\n.label-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.tag-remove {\n  background: none;\n  border: none;\n  color: #93c5fd;\n  font-size: 15px;\n  line-height: 1;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.tag-remove:hover {\n  color: #1d4ed8;\n}\n\n.tag-text-input {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  color: #374151;\n  flex: 1;\n  min-width: 100px;\n  background: transparent;\n}\n\n.tag-text-input::placeholder {\n  color: #9ca3af;\n}\n\n.prelabel-card-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.prelabel-card-section > span {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.mode-toggle {\n  display: flex;\n  gap: 0;\n  width: 100%;\n  border: 1px solid #d8e0ec;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 4px;\n  overflow: hidden;\n}\n\n.mode-btn {\n  flex: 1;\n  min-height: 38px;\n  padding: 8px 6px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease;\n}\n\n.mode-btn.active {\n  background: #111827;\n  color: #fff;\n}\n\n.mode-btn.active:hover {\n  background: #1f2937;\n}\n\n.mode-btn:hover:not(.active) {\n  background: #fff;\n  color: #0f172a;\n}\n\n.model-select-wrapper {\n  align-items: stretch;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.model-button-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.model-button-group .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.dinov2-image-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 12px; }\n.dinov2-image-tile { display: flex; flex-direction: column; gap: 4px; min-width: 0; padding: 6px; background: white; border: 2px solid #ddd; border-radius: 8px; }\n.dinov2-image-tile.selected { border-color: #2563eb; background: #eff6ff; }\n.dinov2-image-tile img { width: 100%; height: 110px; object-fit: contain; }\n.dinov2-image-tile span { overflow-wrap: anywhere; font-size: 12px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
